"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { AdvancedPriceChart, type Timeframe } from "./advanced-price-chart";
import { api } from "@/lib/trpc/client";
interface TokenChartSectionProps {
  slug: string;
  symbol: string;
  tokenName: string;
  initialPrice?: number | null;
  circulatingSupply?: number | null;
  marketCap?: number | null;
}
export function TokenChartSection(t0) {
  const $ = _c(22);
  const {
    slug,
    symbol,
    tokenName
  } = t0;
  const [timeframe, setTimeframe] = useState("1M");
  let t1;
  if ($[0] !== slug || $[1] !== timeframe) {
    t1 = {
      slug,
      timeframe
    };
    $[0] = slug;
    $[1] = timeframe;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      staleTime: 300000
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    isPending
  } = api.token.getOhlc.useQuery(t1, t2);
  const t3 = `${tokenName} price chart`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="text-lg font-semibold text-white">Price chart</h2>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== symbol) {
    t5 = symbol.toUpperCase();
    $[5] = symbol;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="mb-3 flex items-baseline gap-2">{t4}<span className="text-sm text-gray-500">{t5} with developer activity overlay</span></div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== data?.candles) {
    t7 = data?.candles ?? [];
    $[9] = data?.candles;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== data?.devScore) {
    t8 = data?.devScore ?? [];
    $[11] = data?.devScore;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isPending || $[14] !== t7 || $[15] !== t8 || $[16] !== timeframe) {
    t9 = <AdvancedPriceChart candles={t7} devScore={t8} timeframe={timeframe} onTimeframeChange={setTimeframe} isLoading={isPending} />;
    $[13] = isPending;
    $[14] = t7;
    $[15] = t8;
    $[16] = timeframe;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t6 || $[20] !== t9) {
    t10 = <section aria-label={t3}>{t6}{t9}</section>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}